// extracted by mini-css-extract-plugin
export default {"subject-list-main__cards":"SubjectCardList_subject-list-main__cards__dzuBI"};